/**
 * External dependencies
 */
import { AxiosInstance, AxiosResponse } from 'axios';

/**
 * Internal dependencies
 */
import Header from '@naruto/naruto-api/src/tools/Header';
import BaseAPI from '@naruto/naruto-api/src/base';
import { BaseResponse } from './types';

class UserAPI extends BaseAPI {
  constructor({ axios, header }: { axios: AxiosInstance; header: Header }) {
    super({ axios, header });
  }

  /* ======== API: user ======== */
  async postUserLogin<Response, Body = undefined>(body?: Body): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.post<Body, AxiosResponse<Response>>('/api/auth/login', body, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async postUserLogout<Response>(): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.post<Body, AxiosResponse<Response>>('/api/auth/logout', undefined, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async getUserMe<Response>(): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.get<undefined, AxiosResponse<Response>>('/api/auth/token', {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }
}

export default UserAPI;
